
import { querySearch } from '@tencent/nb-h5-tools';
import Session from '@/utils/session.js';
import jsBridge from '@tencent/nb-js-bridge';
import { curEnv, ENV_ENUM } from '@tencent/nb-h5-tools/env';

const isApp = curEnv === ENV_ENUM.APP_ANDROID || curEnv === ENV_ENUM.APP_IOS;
const getUserTicketFromBridge = async () => {
  try {
    const tickets = await jsBridge.Ares.getUserTicket();
    return tickets;
  } catch (err) {
    console.log(err);
  }
};

/**
 * 在 H5 页面注入登录态
 * 目前 H5 中没有登录能力, 主要有宿主环境提供登录票据.
 * 登录态主要有两个信息: uid/skey
 * uid: 用户id
 * skey: 用户登录态token, 有实效性
 */
const Auth = {
  async beforeCreate() {
    let uid; let skey;
    // app 环境下优先走 jsbridge 取
    if (isApp) {
      // app 环境, 从 jsbridge 去取
      const tickets = await getUserTicketFromBridge();
      if (tickets) {
        uid = tickets.uid;
        skey = tickets.skey;
      }
    }
    // 默认通过 url
    if (!uid || !skey) {
      // 其他情况下, 从 url 上取
      uid = querySearch('uid', true);
      skey = querySearch('skey', true);
    }
    // 鉴权信息都存在的情况下, 去设置 cookie
    if (uid && skey) {
      Session.setTickets(uid, skey, '.qq.com');
    }
  },
};

export default Auth;
